<template>
  <v-dialog
      v-model="showDialog"
      max-width="300px"
      persistent
      scrollable
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Filter: Stammauftrag</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-select
                    :items="districts"
                    label="Ortsteile"
                    v-model="filter.selectedDistrict"
                    clearable
          ></v-select>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="showDialog = false"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            @click="submit"
            :disabled="!canSubmit"
        >
          Anwenden
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>

export default {
  name: "QuickTaskDialog",
  props: {
    districts: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      showDialog: false,
      filter: {
        selectedDistrict: '',
      },
    }
  },
  computed: {
    canSubmit() {
      return true;
    },
  },
  watch: {

  },
  methods: {
    show(filter) {
      if (this.showDialog) {
        return;
      }
      this.filter = {...filter};
      this.showDialog = true;
    },
    submit() {
      if (!this.filter.selectedDistrict) {
        this.filter.selectedDistrict = '';
      }
      this.$emit('submit', this.filter);
      this.showDialog = false;
    },
  }
}
</script>

<style scoped>
::v-deep .blue-chips .theme--light.v-chip:not(.v-chip--active) {
  background-color: #1976D2;
  color: white;
}
</style>

